import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { PartnerWizardComponent } from '../../cwc-partner-wizard';
import { TradingPartner } from '../../resolver/trading-partner-resolver';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardChannelsHeaderTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardChannelsHeaderTemplate: FunctionalComponent<PartnerWizardChannelsHeaderTemplateProps> = ({
  controller,
}) => {
  const partner: TradingPartner = controller.getPartnerData();

  if (!partner) {
    return <h3>{controller.textChannelsModalHeadline}</h3>;
  }

  return (
    <div class="channels-header">
      <back-icon onClick={() => controller.setStep('partners')}>
        <slot name={'partner-back-icon'}>
          <svg viewBox={`0 0 24 24`}>{PlaceholderIcons.svgFullArrowRight()}</svg>
        </slot>
      </back-icon>

      <img src={partner.tpImage} alt={partner.tpImageAlt} class="partner-image" />

      <h3>{controller.textChannelsModalHeadline}</h3>
    </div>
  );
};

export default PartnerWizardChannelsHeaderTemplate;
